export type SubscriptionInventoryDetail = {
  isAvailable: boolean
  unavailableProducts: UnavailableProduct[]
}

export type UnavailableProduct = {
  productVariantId: string
  productName: string
  sku: string
  reason: string
  outOfStockEndDate?: Date
  inventoryItemAvailabilityScheduleId?: string
}

export enum InventoryStatus {
  OUT_OF_STOCK = 'OUT_OF_STOCK',
}
